import FormInternalDivTemplate from "../formTemplate/FormInternalDivTemplate";
import React, {FormEvent, useContext, useEffect, useState} from "react";
import {IMessageErrorResponse, IMessageSender} from "../../interfaces/messageInterface";
import axios from "axios";
import {AppContext} from "../context/AppContext";
import {IAuth} from "../../interfaces/interface";
import FormSubmitButton from "../formTemplate/FormSubmitButton";
import HeaderTemplate from "../HeaderTemplate";
import PopMessage from "../PopMessage/PopMessage";

function SingleTracker() {
    const [deviceId, setDeviceId] = useState('');
    const [deviceIdArr, setDeviceIdArr] = useState<string[]>([]);
    const [error, setError] = useState('');

    const {
        authorization,
        errorHandlerFunction: errorHandler,
        navBarClickHandler,
        disMessage
    } = useContext(AppContext);
    const [displayMessage]: string[] = disMessage;
    const [, setDisplayMessage]: React.Dispatch<React.SetStateAction<string>>[] = disMessage;
    const [auth]: IAuth[] = authorization;

    const deviceIdChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        let input = e.target.value.toUpperCase();
        const isValid = /^[0-9a-fA-F]+$/.test(input) || input === "";
        if (!isValid) return;

        setDeviceId(input);
        if (input.length < 3) {
            setDeviceIdArr([])
            setError('ID too short');
            return;
        }

        const messageBody: IMessageSender = {
            type: 'getDeviceIDs',
            userId: auth.username,
            deviceIdFilter: {
                Type: "Unregistered Trackers",
                Pattern: input,
            }
        }
        axios.post('/message', messageBody, auth.header
        ).then(res => {
            if (res.data.status === "OK") {
                setDeviceIdArr(res.data.names)
                if (res.data.names.includes(input)) {
                    setError('');
                } else {
                    setError('No match');
                }
            } else {
                setDeviceIdArr([])
                setError(res.data.errorDescription);
            }
        }).catch(({response}: IMessageErrorResponse) => {
            const errorMessage = errorHandler(response.data.status)
            setError(errorMessage)
        })
    }

    const onSubmit = (e: FormEvent) => {
        e.preventDefault();
        if (!deviceId || error) return;
        const messageBody: IMessageSender = {
            type: 'trackerRegistration',
            userId: auth.username,
            data: deviceId
        }
        setDisplayMessage("processing");
        axios.post('/message', messageBody, auth.header
        ).then(res => {
            if (res.data.status === "OK") {
                setDisplayMessage("done");
            } else {
                setError(res.data.errorDescription)
                setDisplayMessage("error");
            }
        }).catch(({response}: IMessageErrorResponse) => {
            const errorMessage = errorHandler(response.data.status)
            setError(errorMessage)
            setDisplayMessage("error");
        })

    }

    return (
        <div className='page-template AddAsset' onClick={navBarClickHandler}>
            <HeaderTemplate title="Single Tracker Registration"/>
            <form className="form-template" onSubmit={onSubmit} style={{marginTop: '30px'}}>
                <div className='form-template-top-container'>
                    <FormInternalDivTemplate
                        id="deviceId"
                        label="Tracker ID *"
                        listId="trackersId"
                        type="list"
                        placeHolder="Enter Tracker ID"
                        array={deviceIdArr}
                        value={deviceId}
                        maxLength={8}
                        displayMessage={Boolean(error)}
                        message={error}
                        onChange={deviceIdChangeHandler}
                        disabled={false}
                    />
                </div>
                <FormSubmitButton text="Register" disabled={false}/>
                {displayMessage !== "none" &&
                    <div className='page-template-pop-message'>
                        <PopMessage
                            assetHandler={() => {}}
                            formData={{}}
                            type={"general"}
                            error={error}
                            errorTitle="Registration failed"
                            errorDescription
                        />
                    </div>
                }
            </form>

        </div>
    );

}

export default SingleTracker;